import { SGeneralForms, SLocalSelected, SLocalTreeSelected, SSegmentedTabs } from 'shj-components'
import React, { useEffect, useRef } from 'react'
import { Cascader, TreeSelect, message, Select, Button, Radio, Input } from 'antd'
import { debounce, isEmpty } from 'lodash-es'
import dayjs from 'dayjs'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import { useSetState } from 'ahooks'
import {
  getProductCommonPage,
  getProductEnums,
  getProductManagementPage,
  priceItemGet,
  priceItemSpecialConfigSave,
  priceItemSpecialConfigUpdateById,
} from '@/services/product.ts'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { replaceRule } from '@/utils/data.ts'

const AddOrEditConfigure = props => {
  const { editRef, companyList, priceItemId, mathType, hasParent } = props
  const ref = useRef()
  console.log(mathType, 'mathType')

  const [state, setState] = useSetState<any>({
    priceMathTypeEnum: [],
    chooseTypeKey: mathType,
    searchValue: '',
    mainPriceItemInfo: {},
  })

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  const tooltipObj = {
    CUSTOM_FORMULA: '',
    CUSTOMER_SUM: '指当前报价中所有已选产品客户价合计',
    GIVEN_CUSTOMER_SUM:
      '指当前报价中指定项已选产品客户价合计，指定项在产品关联费用项后进行勾选设置',
    CHILD_SUM: '等于当前子费用项的费用合计',
    CREATOR_ENTRY: '指价格由报价人自行输入，满足下面最大值最小值要求，最大值最小值不设置则代表不限',
    REGULAR: '',
    IMPORT_DATA:
      '保存费用后在该费用行上，点击导入费用，进行费用导入。主要用于与套内面积、卫生间个数相关的费用场景。',
  }
  useEffect(() => {
    // 获取主数据
    priceItemGet(priceItemId).then(res => {
      setState({
        mainPriceItemInfo: res,
      })
    })
  }, [])
  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    onFormRef()?.resetFields()
    setRuleModal({ value: '' })
    if (!isEmpty(props.record)) {
      const obj = {
        ...props.record,
        productIdList: props.productId?.split(','),
        startDate: dayjs(props.record.startDate),
        endDate: props.record.endDate && dayjs(props.record.endDate),
      }
      onFormRef()?.setFieldsValue(obj)
      setRuleModal({ value: obj.formulaRule })
    }
  }, [props.record])

  const getOptions = async () => {
    const priceMathTypeEnum = await getProductEnums(
      'com.shj.saas.plus.product.enums.PriceMathTypeEnum'
    )
    setState({
      priceMathTypeEnum: priceMathTypeEnum
        .map(item => ({
          label: item.description,
          value: item.key,
        }))
        .filter(item => item.value !== 'IMPORT_DATA'),
    })
    return Promise.resolve({})
  }

  const onFinish = () => {
    if (state.chooseTypeKey === 'CUSTOM_FORMULA' && !ruleModal.value)
      return message.error('自定义公式，规则不能为空')
    onFormRef()
      ?.validateFields()
      .then(values => {
        props.setLoading?.(true)
        const values_ = {
          ...values,
          startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
          endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
          priceItemId,
          formulaRule: ruleModal.value,
        }
        const apiUrl = values.id ? priceItemSpecialConfigUpdateById : priceItemSpecialConfigSave
        apiUrl({ data: values_ })
          .then(res => {
            message.success(res.message || '操作成功')
            props.fn?.()
            props.onClose?.()
          })
          .finally(() => props.setLoading?.(false))
      })
  }

  if (editRef.current) editRef.current.onFinish = onFinish

  return (
    <>
      <SGeneralForms
        ref={ref}
        layout={'vertical'}
        initialValues={{
          mathType: state.chooseTypeKey,
          showFlag: true,
          editFlag: state.mainPriceItemInfo?.editFlag,
          comparedSubFlag: state.mainPriceItemInfo?.comparedSubFlag,
        }}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { name: 'id', hidden: true },
              {
                name: 'mathType',
                label: '计算方式',
                required: true,
                rules: [{ required: true, message: '计算方式不能为空' }],
                isDeps: true,
                deps: () => {
                  return mathType && mathType !== 'undefined'
                },
                spanCol: 24,
                children: (
                  <Radio.Group
                    className={'radioGroupBox'}
                    disabled={true}
                    options={state.priceMathTypeEnum}
                  />
                ),
                // children: <SSegmentedTabs style={{padding: 0}} disabled={true}
                //                           options={state.priceMathTypeEnum}/>
              },
              {
                spanCol: 24,
                isDeps: true,
                deps: () => tooltipObj[state.chooseTypeKey],
                children: () => {
                  return (
                    <div
                      style={{
                        marginTop: '-20px',
                        marginLeft: 5,
                        color: '#a9a9a9',
                      }}
                    >
                      {tooltipObj[state.chooseTypeKey]}
                    </div>
                  )
                },
              },
              {
                label: '',
                spanCol: 24,
                isDeps: true,
                deps: form => form.getFieldValue('mathType') === 'CUSTOM_FORMULA',
                children: (
                  <div style={{ marginTop: -8 }}>
                    <Button onClick={() => setRuleModal({ open: true })}>编辑公式</Button>
                    {ruleModal?.value && (
                      <Input.TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        disabled
                        style={{ marginTop: 6 }}
                        value={replaceRule(ruleModal.value)}
                      />
                    )}
                  </div>
                ),
              },
              {
                label: '加乘比例',
                name: 'additiveRatio',
                spanCol: 24,
                isDeps: true,
                tooltip:
                  '加乘比例指计算结果值是否再乘以特定比例，不输入表示不加乘，与输入1结果相同',
                deps: form =>
                  ['GIVEN_CUSTOMER_SUM', 'CHILD_SUM'].includes(form.getFieldValue('mathType')),
                type: 'inputNumber',
                comConfig: {
                  min: 0,
                },
              },
              {
                label: '金额',
                spanCol: 24,
                name: 'price',
                required: true,
                rules: [{ required: true, message: '金额不能为空' }],
                isDeps: true,
                deps: form => form.getFieldValue('mathType') === 'REGULAR',
                type: 'inputNumber',
                comConfig: {
                  min: 0,
                  precision: 2,
                },
              },
              {
                label: '是否比差',
                name: 'comparedSubFlag',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                  disabled: onFormRef()?.getFieldValue('mathType') === 'CREATOR_ENTRY',
                },
              },
              {
                spanCol: 24,
                children: (
                  <div
                    style={{ marginTop: -10, marginBottom: 10, marginLeft: 5, color: '#a9a9a9' }}
                  >
                    比差代表报价时：当前费用项值=计算方式算出价格-该费用项已确认报价累计值
                  </div>
                ),
              },
              {
                label: '是否显示',
                name: 'showFlag',
                spanCol: 24,
                isDeps: true,
                deps: () => hasParent === 'true',
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                label: '是否可编辑',
                name: 'editFlag',
                spanCol: 24,
                isDeps: true,
                deps: form =>
                  form.getFieldValue('otherConfigType') !== 'LOAN_INTEREST' &&
                  form.getFieldValue('showFlag') &&
                  form.getFieldValue('mathType') !== 'CREATOR_ENTRY',
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'productIdList',
                label: '适用产品',
                required: true,
                deps: () => !props.record.id,
                isDeps: true,
                rules: [{ required: true, message: '适用产品不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSelect
                    allowClear
                    label={'适用产品'}
                    isCommon={true}
                    mode={'multiple'}
                    fixedParams={{ prodTypes: ['PRODUCT_PACKAGE'] }}
                    fetchOptions={getProductCommonPage}
                    fieldNames={{ label: 'prodName', value: 'id' }}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '适用门店',
                name: 'orgIdList',
                required: true,
                deps: () => !props.record.id,
                isDeps: true,
                rules: [{ required: true, message: '适用门店不能为空' }],
                children: (
                  <Select
                    placeholder={'请选择适用门店'}
                    treeDefaultExpandAll
                    mode={'multiple'}
                    allowClear
                    showSearch
                    optionFilterProp={'name'}
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    fieldNames={{ label: 'name', value: 'id' }}
                    options={companyList}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '开始日期',
                name: 'startDate',
                required: true,
                rules: [{ required: true, message: '开始日期不能为空' }],
                type: 'date',
              },
              {
                spanCol: 24,
                label: '结束日期',
                name: 'endDate',
                type: 'date',
                comConfig: {
                  disabledDate: current => {
                    const startDate = onFormRef().getFieldValue('startDate')
                    if (startDate) return current && current < dayjs(startDate).endOf('day')
                  },
                },
              },
            ],
          },
        ]}
      />
      <RulesModal
        modalProps={{ ...ruleModal }}
        onCancel={() => setRuleModal({ open: false })}
        onOk={(value: string) => setRuleModal({ value })}
      />
    </>
  )
}

export default AddOrEditConfigure
